export default __webpack_public_path__ + "static/media/man.8f117eb2.svg";